import {ScenariosCommandHandlerBase} from '@features/scenarios-core/services/handlers/scenarios-command-handler-base';
import {
    IPlatformCommandHandler,
    IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ManageTransactionsCommandHandler extends ScenariosCommandHandlerBase implements IPlatformCommandHandler {

    constructor(public router: Router,
                public commandService: CommandService,
                public fuseSplashScreenService: FuseSplashScreenService,
                public snackBarService: SnackBarService) {
        super(router, commandService, fuseSplashScreenService, snackBarService);
    }

    executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
        command.fieldValues['FilterId'] = `ManageTransaction-${command.fieldValues['ScenarioId']}`;
        this.executeCommandToApi(command, handler);
        return true;
    }

}
